export const CREDITOS_MODO = {
    TODOS: 'TODOS',
    SELECCION: 'SELECCION',
    NINGUNO: 'NINGUNO',
}
